<div class="absolute inset-x-0 bottom-2 flex justify-center">
  <div class="flex items-center rounded-sm bg-white">
    @for (item of controls; track $index) {
      <button
        type="button"
        class="flex items-center p-3 first:rounded-l-sm last:rounded-r-sm hover:cursor-pointer hover:bg-green-200"
        [ngClass]="{ 'bg-green-300': selectedControl === $index }"
        [title]="item.name"
        (click)="onSelect($index)"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
      </button>
    }
  </div>
</div>
